import React from 'react';
import {createRoot} from 'react-dom/client';

import App from '-/App';
import {observeProtectedFileSession} from '-/data/protectedFiles';
import SessionAccessGate from '@embertracking/ui/components/SessionAccessGate';
import MaintenanceGate from '@embertracking/ui/components/MaintenanceGate';
import {auth, db} from '-/firebase';
import {callFunction} from '-/data/utils';

import '@embertracking/ui/style/style.css';

const container = document.getElementById('root');
observeProtectedFileSession();
const root = createRoot(container);
const renewAccess = () => callFunction('refreshSessionAccess', {}, {timeout: 25000});
const checkMaintenance = () => callFunction('maintenanceStatus', {}, {timeout: 15000});
root.render((
    <MaintenanceGate auth={auth} check={checkMaintenance}>
        <SessionAccessGate auth={auth} db={db} renew={renewAccess}><App /></SessionAccessGate>
    </MaintenanceGate>
));
